/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum RelationSourceType {
  user = "user",
}

export enum RelationTargetType {
  content = "content",
  space = "space",
}

export enum RelationType {
  collaborator = "collaborator",
  favourite = "favourite",
  touched = "touched",
}

export interface UpdateRelationInput {
  relationName: RelationType;
  sourceKey: string;
  sourceStatus?: string | null;
  sourceType: RelationSourceType;
  sourceVersion?: number | null;
  targetKey: string;
  targetStatus?: string | null;
  targetType: RelationTargetType;
  targetVersion?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetRelationMutation
// ====================================================

export interface SetRelationMutation_updateRelation {
  targetKey: string;
  sourceKey: string;
  relationName: string;
  url: string;
}

export interface SetRelationMutation {
  updateRelation: SetRelationMutation_updateRelation | null;
}

export interface SetRelationMutationVariables {
  input: UpdateRelationInput;
}
